import { render, staticRenderFns } from "./ComboMensagemPronta.vue?vue&type=template&id=3500187a"
import script from "./ComboMensagemPronta.vue?vue&type=script&lang=ts"
export * from "./ComboMensagemPronta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports